module.exports = __webpack_public_path__ + "img/uid-token-game-guide-global.36a8c66e.png";